import { ShoppingCart, MapPin, Truck, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function HowItWorks() {
  const steps = [
    { icon: ShoppingCart, title: '1. Elige tus productos', desc: 'Explora miles de víveres, productos frescos, bebidas y combos.' },
    { icon: MapPin, title: '2. Indica el destinatario', desc: 'Añade los datos de tu familiar en cualquier provincia de Cuba.' },
    { icon: Truck, title: '3. Elige la entrega', desc: 'Estándar o Express (mismo día en La Habana).' },
    { icon: CheckCircle, title: '4. Recibe la confirmación', desc: 'Rastrea tu pedido y recibe notificaciones de entrega.' },
  ];
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="font-heading font-black text-3xl text-[#1a3a5c] text-center mb-2">Cómo Funciona</h1>
      <p className="text-center text-muted-foreground mb-10">Enviar a tu familia en Cuba nunca fue tan fácil.</p>
      <div className="grid sm:grid-cols-2 gap-6">
        {steps.map((s, i) => (
          <div key={i} className="bg-card rounded-xl border border-border p-6"><div className="w-12 h-12 rounded-full bg-[#1a3a5c]/10 flex items-center justify-center mb-4"><s.icon className="h-6 w-6 text-[#1a3a5c]" /></div><h3 className="font-heading font-bold text-lg text-foreground mb-1">{s.title}</h3><p className="text-sm text-muted-foreground">{s.desc}</p></div>
        ))}
      </div>
      <div className="text-center mt-10"><Link to="/productos"><Button className="bg-[#c8860a] hover:bg-[#c8860a]/90 rounded-full px-8 h-11">Empezar a Comprar</Button></Link></div>
    </div>
  );
}
